import { Section, SectionHeading } from "@components/shared/Section";
import { UNLOCK } from "@/lib/site";
import { useTranslations } from "@services/strings";
import { Landmark, ShieldCheck, Smartphone } from "lucide-react";

/** Three reasons, written as claims with evidence — no icon grid of slogans. */
export const Why = () => {
  const { t, formatNumber } = useTranslations();

  const items = [
    {
      icon: ShieldCheck,
      title: t("site.home.why.items.licensed.title"),
      body: t("site.home.why.items.licensed.body"),
    },
    {
      icon: Landmark,
      title: t("site.home.why.items.asset.title"),
      body: t("site.home.why.items.asset.body", {
        maxAmount: formatNumber(UNLOCK.maxAmount),
        maxYears: UNLOCK.maxYears,
      }),
    },
    {
      icon: Smartphone,
      title: t("site.home.why.items.digital.title"),
      body: t("site.home.why.items.digital.body"),
    },
  ];

  return (
    <Section tone="white">
      <div className="grid gap-12 md:grid-cols-[0.8fr_1.2fr] md:gap-16">
        <SectionHeading title={t("site.home.why.title")} />
        <dl className="flex flex-col divide-y divide-slate-200">
          {items.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-5 py-7 first:pt-0 last:pb-0">
              <span className="mt-0.5 grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-mint-soft text-mint-ink">
                <Icon size={20} aria-hidden="true" />
              </span>
              <div>
                <dt className="text-h3 font-semibold">{title}</dt>
                <dd className="mt-2 max-w-prose text-body text-slate-600">
                  {body}
                </dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </Section>
  );
};
